import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { delUser, getUploadData, getUserList, initPw, regist, updtUser } from 'services/api-service/center';
import { utilService } from 'services/util-service';
import { IUser } from 'store/modules/user';
import ModalDelete from './ModalDelete';
import ModalInitialize from './ModalInitialize';

const ManagerUser = ({ userInfo }: IUser) => {
  const [selected, setSelected] = useState(undefined);
  const [group, setGroup] = useState({
    first: '서해청',
    firstIndex: 2,
    second: '완도',
    secondIndex: 4,
    third: '마량파출소',
    thirdIndex: 117,
  });
  const [searchFilter, setSearchFilter] = useState({
    category: 'nm', // nm(이름), ph(전화번호), id(아이디)
    keyword: '',
  });
  const [datas, setDatas] = useState<any[] | undefined>(undefined);
  const [users, setUsers] = useState<any[] | undefined>(undefined);
  const [openDelete, setOpenDelete] = useState<any>(undefined);
  const [openInitialize, setOpenInitialize] = useState<any>(undefined);
  const [register, setRegister] = useState({
    userId: '',
    userName: '',
    pw: null,
    userPhone: '',
    role: 'A',
    group: '1',
    oiIdx: '',
    status: 'P',
  });
  const hasPermission = userInfo.belong === group.third || userInfo.role === 'S';

  const getOrganizations = async () => {
    try {
      const response: any = await getUploadData();
      if (response.result === 'success') {
        const dataList = response.dataList;
        setDatas(dataList);
        const findPathWithIndex = (nodes: any[], target: string, path: any[] = []): any => {
          for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const currentPath = [...path, { ...node, arrayIndex: i }];

            if (node.label && node.label.includes(target)) {
              return currentPath;
            }

            if (node.children && node.children.length > 0) {
              const foundPath = findPathWithIndex(node.children, target, currentPath);
              if (foundPath) return foundPath;
            }
          }
          return null;
        };
        if (userInfo.role === 'S') {
          getUsers(group.thirdIndex);
        } else {
          const resultPath = findPathWithIndex(dataList, userInfo.belong);
          if (resultPath) {
            const lv1 = resultPath[0];
            const lv2 = resultPath[1];
            const lv3 = resultPath[2];
            setGroup({
              first: lv1?.label || '',
              firstIndex: lv1 !== undefined ? lv1.arrayIndex : 0,
              second: lv2?.label || '',
              secondIndex: lv2 !== undefined ? lv2.arrayIndex : 0,
              third: lv3?.label || '',
              thirdIndex: lv3?.value || 0,
            });
            getUsers(lv3?.value);
          }
        }
      }
    } catch (error) {
      console.error('getOrganizations Error:', error);
    }
  };

  const getUsers = async (index: number | null) => {
    try {
      const response: any = await getUserList(index, searchFilter.category, searchFilter.keyword);
      if (response.result === 'success') {
        setUsers(response.datas);
      }
    } catch (error) {
      console.log('getUsers Error ', error);
    }
  };

  const onCloseInitialize = async (item: any) => {
    if (item) {
      const success = await onPassword(item);
      if (success) setOpenInitialize(undefined);
    } else {
      setOpenInitialize(undefined);
    }
  };

  const onCloseDelete = async (item: any) => {
    if (item) {
      const success = await onDelete(item);
      if (success) setOpenDelete(undefined);
    } else {
      setOpenDelete(undefined);
    }
  };

  const onRegister = async (item: any, isClear: boolean) => {
    if (utilService.isEmpty(item.userId)) {
      return toast('아이디를 입력 바랍니다.', { type: 'error' });
    } else if (utilService.isEmpty(item.userPhone) || item.userPhone.length < 11) {
      return toast('전화번호를 정확히 입력해 주세요', { type: 'error' });
    } else if (utilService.isEmpty(item.userName)) {
      return toast('이름을 정확히 입력해 주세요.', { type: 'error' });
    }
    if (isClear) {
      try {
        const response: any = await regist(
          item.userId,
          item.userName,
          item.pw,
          item.userPhone.replace(/-/g, ''),
          item.role,
          item.group,
          group.thirdIndex
        );
        if (response.result === 'success') {
          setRegister({
            ...register,
            userId: '',
            userName: '',
            pw: null,
            userPhone: '',
            role: 'A',
            group: '1',
            oiIdx: '',
          });
          getUsers(group.thirdIndex);

          return toast('등록되었습니다.', { type: 'success' });
        } else {
          return toast(response.error_msg, { type: 'error' });
        }
      } catch (error) {
        console.log('onRegister Error ', error);
      }
    } else {
      try {
        const response: any = await updtUser(
          item.userIdx,
          item.userId,
          item.userName,
          item.userPhone.replace(/-/g, ''),
          item.role,
          item.group,
          group.thirdIndex,
          item.status
        );
        if (response.result === 'success') {
          getUsers(group.thirdIndex);
          return toast('등록되었습니다.', { type: 'success' });
        }
      } catch (error) {
        console.log('onRegister Error ', error);
      }
    }
  };

  const onStatusChange = async (item: any, newStatus: string) => {
    if (!hasPermission) return;

    const updatedUser = {
      ...item,
      status: newStatus,
    };
    setUsers((prevUsers) => prevUsers?.map((user) => (user.userIdx === item.userIdx ? updatedUser : user)));
    await onRegister(updatedUser, false);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  const onSearch = async () => {
    setSelected(undefined);
    // Search
    getUsers(group.thirdIndex);
  };

  const onPassword = async (item: any) => {
    try {
      const response: any = await initPw(item.userIdx);
      if (response.result === 'success') {
        return toast('비밀번호를 초기화하였습니다.', { type: 'success' });
      }
    } catch (error) {
      console.log('onPassword Error ', error);
    }
  };

  const onModify = async (item: any) => {
    if (selected === item.userIdx) {
      // Register
      setSelected(undefined);
      onRegister(item, false);
    } else {
      setSelected(item.userIdx);
    }
  };

  const onDelete = async (item: any) => {
    try {
      const response: any = await delUser(item.userIdx);
      if (response.result === 'success') {
        getUsers(group.thirdIndex);
        return toast('사용자를 삭제하였습니다.', { type: 'success' });
      }
    } catch (error) {
      console.log('onDelete Error ', error);
    }
  };

  const onChangeGroup = (e: any) => {
    const { name, value, selectedIndex } = e.target;
    // console.log('onChangeGroup  ', name, value, selectedIndex);
    if (name === 'first') {
      setGroup({
        ...group,
        [name]: value,
        [name + 'Index']: selectedIndex,
        ['second']: datas![selectedIndex].children[0].value,
        ['secondIndex']: 0,
        ['third']: datas![selectedIndex].children[0].children[0].label,
        ['thirdIndex']: datas![selectedIndex].children[0].children[0].value,
      });
    } else if (name === 'second') {
      setGroup({
        ...group,
        [name]: value,
        [name + 'Index']: selectedIndex,
        ['third']: datas![group.firstIndex].children[selectedIndex].children[0].label,
        ['thirdIndex']: datas![group.firstIndex].children[selectedIndex].children[0].value,
      });
    } else {
      // find userIdx
      setGroup({
        ...group,
        [name]: datas![group.firstIndex].children[group.secondIndex].children[selectedIndex].label,
        [name + 'Index']: datas![group.firstIndex].children[group.secondIndex].children[selectedIndex].value,
      });
    }
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === 'userPhone') {
      setRegister({ ...register, [name]: utilService.formatPhoneNumber(value) });
    } else {
      setRegister({ ...register, [name]: value });
    }
  };

  const onModifyHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    // console.log('onModifyHandler  ', selected, name, value);
    // Find selected item & set data
    setUsers((prevUsers) =>
      prevUsers?.map((user) => {
        if (user.userIdx === selected) {
          return {
            ...user,
            [name]: name === 'userPhone' ? utilService.formatPhoneNumber(value) : value,
          };
        }
        return user;
      })
    );
  };

  useEffect(() => {
    getOrganizations();
  }, []);

  return (
    <ManagerRescueTemplateWrap>
      <TitleWrap>사용자 관리</TitleWrap>
      <SearchWrap>
        <SearchRow>
          <SelectGroup onChange={onChangeGroup} name="first" value={group.first || ''}>
            {datas &&
              datas.map((data, index) => (
                <option key={index} value={data.value}>
                  {data.label}
                </option>
              ))}
          </SelectGroup>
          <SelectGroup onChange={onChangeGroup} name="second" value={group.second || ''}>
            {datas &&
              datas[group.firstIndex]?.children.map((first, index) => (
                <option key={index} value={first.value}>
                  {first.label}
                </option>
              ))}
          </SelectGroup>
          <SelectGroup onChange={onChangeGroup} name="third" value={group.third || ''}>
            {datas &&
              datas[group.firstIndex]?.children[group.secondIndex]?.children.map((second, index) => (
                <option key={index} value={second.label}>
                  {second.label}
                </option>
              ))}
          </SelectGroup>
        </SearchRow>

        <SearchRow>
          <SelectGroup
            value={searchFilter.category}
            onChange={(e) => setSearchFilter({ ...searchFilter, category: e.target.value })}
          >
            <option value="nm">이름</option>
            <option value="ph">전화번호</option>
            <option value="id">아이디</option>
          </SelectGroup>
          <SearchInput
            placeholder={
              searchFilter.category === 'nm'
                ? '이름으로 검색하세요.'
                : searchFilter.category === 'ph'
                ? '전화번호 11자리를 입력하여 검색하세요.'
                : '아이디로 검색하세요.'
            }
            value={searchFilter.keyword}
            onChange={(e) => setSearchFilter({ ...searchFilter, keyword: e.target.value })}
            onKeyDown={onKeyDown}
          />
          <SearchButton onClick={onSearch}>검색</SearchButton>
        </SearchRow>
      </SearchWrap>
      <RegisterWrap>
        <table>
          <tbody>
            <tr>
              <th>
                <RegisterInputWrap
                  name="userName"
                  type="text"
                  value={register.userName}
                  placeholder="이름"
                  onChange={onChangeHandler}
                  disabled={!hasPermission}
                />
              </th>
              <th>
                <RegisterInputWrap
                  name="userPhone"
                  type="text"
                  value={register.userPhone}
                  placeholder="전화번호"
                  onChange={onChangeHandler}
                  disabled={!hasPermission}
                />
              </th>
              <th>
                <RegisterInputWrap
                  name="userId"
                  type="text"
                  value={register.userId}
                  placeholder="아이디"
                  onChange={onChangeHandler}
                  disabled={!hasPermission}
                />
              </th>
              <th style={{ width: '15rem' }}>
                <RegisterButton disabled={!hasPermission} onClick={() => onRegister(register, true)}>
                  등록
                </RegisterButton>
              </th>
            </tr>
          </tbody>
        </table>
      </RegisterWrap>
      <TableWrap>
        <table>
          <tbody>
            <tr>
              <th style={{ width: '5rem' }}>No.</th>
              <th>이름</th>
              <th>전화번호</th>
              <th>아이디</th>
              <th>비밀번호</th>
              <th style={{ width: '15rem' }}>수정 / 삭제</th>
              <th>상태</th>
            </tr>
            {users !== undefined &&
              users.map((item, index) => (
                <tr key={index}>
                  <td style={{ width: '5rem' }}>{index + 1}</td>
                  <td>
                    <InputWrap
                      type="text"
                      name="userName"
                      value={item.userName}
                      disabled={selected !== item.userIdx}
                      onChange={onModifyHandler}
                    ></InputWrap>
                  </td>
                  <td>
                    <InputWrap
                      type="text"
                      name="userPhone"
                      value={utilService.formatPhoneNumber(item.userPhone)}
                      disabled={selected !== item.userIdx}
                      onChange={onModifyHandler}
                      maxLength={13}
                    />
                  </td>
                  <td>
                    <InputWrap
                      type="text"
                      name="userId"
                      value={item.userId}
                      disabled={selected !== item.userIdx}
                      onChange={onModifyHandler}
                    ></InputWrap>
                  </td>
                  <td>
                    <PasswordButton disabled={!hasPermission} onClick={() => setOpenInitialize(item)}>
                      비밀번호초기화
                    </PasswordButton>
                  </td>
                  <td style={{ width: '15rem' }}>
                    <ModifyButton disabled={!hasPermission} onClick={() => onModify(item)}>
                      {selected === item.userIdx ? '등록' : '수정'}
                    </ModifyButton>
                    <DeleteButton disabled={!hasPermission} onClick={() => setOpenDelete(item)}>
                      삭제
                    </DeleteButton>
                  </td>
                  <td>
                    <SelectButton
                      value={item.status}
                      disabled={!hasPermission}
                      onChange={(e) => onStatusChange(item, e.target.value)}
                    >
                      <option value="P">활성</option>
                      <option value="L">잠김</option>
                    </SelectButton>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </TableWrap>
      {openInitialize && <ModalInitialize item={openInitialize} onClose={onCloseInitialize} />}
      {openDelete && <ModalDelete item={openDelete} onClose={onCloseDelete} />}
    </ManagerRescueTemplateWrap>
  );
};

const ManagerRescueTemplateWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;
const TitleWrap = styled.div`
  text-align: center;
  align-content: center;
  width: 18.75rem;
  height: 3.4375rem;
  cursor: pointer;
  background: radial-gradient(#cf1900, #000000);
  border-radius: 0.625rem;
  border: 1px solid;
  border-color: #cf1900;
  color: #ffffff;
  font-family: Inter;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  margin: 4rem auto;
`;
const SearchWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 90%;
  min-width: 68.0625rem;
  margin: 0 auto 20px;
  padding: 25px;
  background: #011f3c;
  border-radius: 15px;
  align-items: center;
`;
const SearchRow = styled.div`
  display: flex;
  gap: 30px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
const SelectGroup = styled.select`
  width: 200px;
  height: 36px;
  font-size: 1rem;
  text-align: center;
  color: #99bcdc;
  background: #012f5a;
  border-radius: 8px;
  border: 1px solid #547d9a;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white' %3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 20px;
`;
const SearchInput = styled.input`
  width: 300px;
  height: 36px;
  background: #668caf;
  border-radius: 8px;
  border: 1px solid #bed8ef;
  color: white;
  padding: 0 15px;
  font-size: 1rem;
  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
`;
const RegisterWrap = styled.div`
  width: 90%;
  min-width: 71.875rem;
  height: 4.25rem;
  margin: 20px auto;
  padding: 15px 45px;
  background: #011f3c;
  border-radius: 10px;
  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  th {
    width: 100%;
    height: 2rem;
    color: #fff;
    // border: 1px solid #547d9a;
  }
`;
const TableWrap = styled.div`
  width: 90%;
  min-width: 71.875rem;
  max-height: 36.575rem;
  border: 1px solid #547d9a;
  // overflow-y: auto;
  margin: auto;
  background: linear-gradient(180deg, #002f5a 0%, #000 100%);

  thead {
    display: block;
    table-layout: fixed;
  }

  tbody {
    max-height: 33.075rem;
    table-layout: fixed;
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
    // margin: 0 5px 0 5px;
    ::-webkit-scrollbar {
      // display: none;
      width: 3px;
    }
    ::-webkit-scrollbar-thumb {
      height: 10%; /* 스크롤바의 길이 */
      background: #0086ff; /* 스크롤바의 색상 */

      border-radius: 10px;
    }
    ::-webkit-scrollbar-track {
      background: rgba(33, 122, 244, 0.1); /*스크롤바 뒷 배경 색상*/
    }
  }

  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    border-bottom: 1px solid #547d9a;
  }
  th {
    width: 100%;
    height: 3.25rem;
    color: #fff;
    border: 1px solid #547d9a;
    vertical-align: middle;
  }
  td {
    vertical-align: middle;
    height: 3.25rem;
    margin: 0;
    color: #fff;
    text-align: center;
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border: 1px solid #547d9a;
    cursor: pointer;
    // :last-child {
    //   border-right: 0;
    // }
  }
`;
const InputWrap = styled.input`
  width: 80%;
  height: 2.25rem;
  color: #ffffff;
  background: #668caf;
  border: 1px solid #e6e6e6;
  border: none;
  text-align: center;
  border-radius: 5px;
  font-size: 1rem;
  ::placeholder {
    color: #ffffff;
  }
  :disabled {
    background: transparent;
    border: none;
  }
`;
const RegisterInputWrap = styled.input`
  width: 80%;
  height: 2.25rem;
  color: #ffffff;
  background: #668caf;
  border: 1px solid #bed8ef;
  text-align: center;
  border-radius: 5px;
  font-size: 1rem;
  ::placeholder {
    color: #ffffff;
  }
  &:disabled {
    background: #444;
    border: 1px solid #666;
    color: #999;
    cursor: not-allowed;
    opacity: 0.7;
    text-shadow: none;
    box-shadow: none;
    ::placeholder {
      color: #777;
    }
  }
`;

const ModifyButton = styled.button`
  width: 70px;
  height: 2.25rem;
  background: #176693;
  border: 2px solid #4f7da7;
  border-radius: 0.625rem;
  color: #fff;
  cursor: pointer;
  &:disabled {
    background: #555;
    border-color: #777;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
const DeleteButton = styled(ModifyButton)`
  margin-left: 1rem;
  background: #763c51;
  border: 2px solid #af6666;
`;
const RegisterButton = styled(ModifyButton)`
  width: 163px;
  height: 2.25rem;
  margin-left: 1rem;
  background: #3c5a76;
  border: 2px solid #668caf;
`;
const PasswordButton = styled(ModifyButton)`
  width: 140px;
  background: #176693;
  border: 2px solid #4f7da7;
`;
const SearchButton = styled(ModifyButton)`
  width: 6.25rem;
  height: 2.25rem;
  background: #1760a6;
  border: 2px solid #4f7da7;
`;
const SelectButton = styled(SelectGroup)`
  width: 135px;
  font-size: 14px;
  color: #fff;
`;

export default ManagerUser;
